import { Route } from '@angular/router';
import { AuthGuard } from 'src/app/_guards';
import { deviationRoutes } from '../deviation/deviation.routing';
import { FeatureDocumentRoutes } from '../feature-documents/feature-document.routing';
import { registrationRoutes } from '../Registration/registration.routing';
import { safetyjobRoutes } from '../safety-job-analysis/jobanalysis.routing';
import { taskmanagerRoutes } from '../task-manager/task-manager.routing';
import { timetableRoutes } from '../time-table/timetable.routing';
import {
  EmployeeContactUserResolver,
  EmployeeContactUserSubscriptionResolver,
} from '../users/services/user.resolver.service';
import { QualitySystemEditComponent } from './components/quality-system-edit.component';
import { QualitySystemListComponent } from './components/quality-system-list.component';
import { QualitySystemViewComponent } from './components/quality-system-view.component';
import { QualitysystemListComponent } from './components/qualitysystem-list.component';
import { QualitySystemComponent } from './quality-system.component';
import {
  InternalControlByUserResolver,
  InternalControlEditResolver,
  InternalControlFeaturesResolver,
  InternalControlResolver,
} from './services/quality-system.resolver.service';

export const qualitySystemRoutes: Route[] = [
  {
    path: 'quality-system',
    component: QualitySystemComponent,
    children: [
      {
        path: 'list',
        component: QualitysystemListComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', redirectTo: 'all', pathMatch: 'full' },
          {
            path: 'own',
            component: QualitySystemListComponent,
            resolve: {
              list: InternalControlByUserResolver,
            },
          },
          {
            path: 'all',
            component: QualitySystemListComponent,
            resolve: {
              list: InternalControlResolver,
            },
          },
        ],
      },
      {
        path: 'create/:id',
        component: QualitySystemEditComponent,
        resolve: {
          contact: EmployeeContactUserResolver,
          users_subscription: EmployeeContactUserSubscriptionResolver,
        },
      },
      {
        path: 'details/:id',
        data: { parent: 'QS' },
        component: QualitySystemViewComponent,
        resolve: {
          list: InternalControlByUserResolver,
          additionalFeatures: InternalControlFeaturesResolver,
          edit: InternalControlEditResolver,
        },
        canActivate: [AuthGuard],
        children: [
          ...FeatureDocumentRoutes,
          ...deviationRoutes,
          ...taskmanagerRoutes,
          ...timetableRoutes,
          ...safetyjobRoutes,
          ...registrationRoutes,
        ],
      },
    ],
  },
];
